import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import {BehaviorSubject} from 'rxjs';
import {FusionAuthService} from '../../../shared/services/fusion-auth';
import {UrlProviderService} from '../../../shared/services/general';
import {SECURED_STORE} from '../../../shared/utils';

@Injectable({
  providedIn: 'root'
})
export class BillingService {

  constructor(private urlProvider: UrlProviderService, private fusionAuthService: FusionAuthService, private router: Router) {
  }

  public billingInfoCustomStore(dataSource: BehaviorSubject<DataSource>): CustomStore {
    return SECURED_STORE({
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT(),
      loadParams: null,
      dataSource,
      routerService: this.router,
      loadUrl: `${this.urlProvider.ApiUrl}/v2/billing-information/bill-types/remote-operations`
    });
  }

  public payerCustomStore(billTypeId: number, allPayers: boolean, dataSource: BehaviorSubject<DataSource>): CustomStore {
    return SECURED_STORE({
      tokenRefresh: this.fusionAuthService.exchangeRefreshTokenForJWT(),
      loadParams: null,
      dataSource,
      routerService: this.router,
      loadUrl: `${this.urlProvider.ApiUrl}/v2/billing-information/payers/remote-operations/${billTypeId}?allPayers=${allPayers}`
    });
  }
}
